'use client'
import { BusinessGrow } from '@/components'
import { DoubleRightArrowIcon } from '@/svgs'
import Link from 'next/link'
import React from 'react'

export default function HeroSection() {
   return (
      <>
         <section className="cs-bg-secondary first-section">
            <div className="container-fluid">
               <div className="g-4 row align-items-center text-center">
                  <div className="col-xl-12 position-relative">
                     <h1 className="intro_title">
                        Transforming Ideas into World-Class Software
                     </h1>
                     <p className="intro_description service-main-desc m-auto">
                        At Benzatine Infotech, We empower businesses with
                        top-tier software development solutions, driving digital
                        transformation with precision and expertise. Our highly
                        experienced developers design 360-degree business
                        solutions, with high performance and real-world results
                        through the most advanced technology stacks.
                     </p>
                     <p className="intro_description service-main-desc m-auto mt-3">
                        Having more than 12+ years of experience in the
                        industry, we are experts in providing trustworthy,
                        scalable, and future-proof software solutions specific
                        to your individual requirements. From conceptualization
                        and design to coding, testing, deployment, and
                        maintenance, our end-to-end development services
                        guarantee smooth automation and digitalization of your
                        business operations.
                     </p>

                     <Link
                        href="/discover-benzatine/contact-us"
                        className="btn bez-fill-btn mt-5"
                     >
                        let’s talk to benzatine
                        <DoubleRightArrowIcon />
                     </Link>
                  </div>
               </div>
            </div>
         </section>
         <BusinessGrow />
      </>
   )
}
